import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import TextInput from "../../../../components/inputs/text";
import CheckboxInput from "../../../../components/inputs/check";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";
import Loading from "../../../../components/loading";

const Form = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	// setLoading,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		//useForm
		register,
		handleSubmit,
		setValue,
		control,
		setFocus,
		handleChangeInt,

		loading,

		//formState
		errors,
		isSubmitting,

		handleCloseModalRegister,
		handleOnSubmit,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		// setLoading,
		fetchID,
		reloadData,
		insert,
	});

	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Aguarde buscando dados no servidor..." />
				</div>
			) : (
				<form
					className="form"
					onSubmit={handleSubmit(
						handleOnSubmit
						// handleOnError
					)}
				>
					<main>
						<div className="row">
							<TextInput
								label="Categoria"
								id="nome"
								placeholder="Categoria"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								autoFocus={true}
								className="col-12 col-sm-12 col-lg-8"
							/>
							<TextInput
								label="Ordem"
								id="ordem"
								placeholder="Ordem Categoria"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								onChange={handleChangeInt}
								className="col-4 col-sm-4 col-lg-6"
							/>
							<TextInput
								label="Observação"
								id="obs"
								placeholder="Obs Categoria"
								register={register}
								errors={errors}
								onKeyDown={libForm.EnterTab}
								className="col-8 col-sm-8 col-lg-6"
							/>

							<CheckboxInput
								label="Ativar Categoria"
								id="ativo"
								register={register}
								errors={errors}
								className="col-12 col-sm-6"
							/>
						</div>
					</main>
					<footer>
						<BtnBack onClick={(e) => handleCloseModalRegister()} isSubmitting={isSubmitting} />
						<BtnSubmit isSubmitting={isSubmitting} />
					</footer>
				</form>
			)}
		</>
	);
};

export default Form;
